// Vendors
import { TitleComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { CANCEL_DROP_MODAL_COMPONENT_TITLE_PROPS } from './constants/cancel-drop-modal-title.constants';
// Styles
import { CancelDropModalTitleComponentStyled } from './cancel-drop-modal-title.component.styled';
// Types
import { CancelDropModalComponentType } from '../../types/cancel-drop-modal.component.type';

const CancelDropModalTitleComponent = ({
  title,
}: Pick<CancelDropModalComponentType, 'title'>): React.JSX.Element => (
  <CancelDropModalTitleComponentStyled>
    <TitleComponent
      {...CANCEL_DROP_MODAL_COMPONENT_TITLE_PROPS}
      title={<FormattedMessage id={title} />}
    />
  </CancelDropModalTitleComponentStyled>
);

export { CancelDropModalTitleComponent };
